// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3yeRV","title":"Info_title__7Saqm","links":"Info_links__2An6c","link":"Info_link__5iHA6","logo":"Info_logo__321k3"};